import React, {useState, useMemo, useEffect} from "react";
import RecentlyViewedContext from "./RecentlyViewedContext";
const RecentlyViewedState = (props) => {
  const [state, setState] = useState([]);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );
  useEffect(() => {
    //console.log("RecentlyViewed items state:", state);
  }, [state]);
  // console.log("all Products in state:", state);
  return (
    <RecentlyViewedContext.Provider value={value}>
      {props.children}
    </RecentlyViewedContext.Provider>
  );
};

export default RecentlyViewedState;
